<template>
    <div>
        <div class="post-box">
            <div class="post-content text-left">
                <h6 class="post-title">
                    İstatistikler
                </h6>
                <ul class="postBox-list">
                    <li class="postBox-item">
                                <span>
                                    <i class="ti-angle-double-right"></i>
                                </span>
                        <a href="javascript:;" v-on:click="openStats">Bir bakista tum istatistikler</a>
                    </li>
                    <li class="postBox-item">
                                <span>
                                    <i class="ti-angle-double-right"></i>
                                </span>
                        <a href="javascript:;" v-on:click="openLiveScore">Sonuclar ve canli skorlar</a>
                    </li>
                    <li class="postBox-item">
                                <span>
                                    <i class="ti-angle-double-right"></i>
                                </span>
                        <a href="javascript:;">Arsivden sonuclar</a>
                    </li>
                </ul>
            </div>
        </div>
        <sweet-modal ref="umodal" width="1200">
            <iframe :src="'https://s5.sir.sportradar.com/universalsoftwaresolutions/en/'" class="iframe-box"></iframe>
        </sweet-modal>

        <sweet-modal ref="lsmodal" width="1200">
            <iframe :src="'https://ls.sir.sportradar.com/universalsoftwaresolutions/en/soccer'"
                    class="iframe-box"></iframe>
        </sweet-modal>
    </div>
</template>

<script>
    export default {
        name: 'statsInfo',
        data () {
            return {
                msg: ''
            }
        },
        methods: {
            openStats() {
                this.$refs.umodal.open();
            },
            openLiveScore() {
                this.$refs.lsmodal.open();
            },
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/sportsbook/widget/statsInfo.vue